import {Key} from 'react';
import {z as r} from 'zod';

import {ReviewsAnalysisModeEnum} from '../reivew-analysis-const';
import {ReviewRateEnum} from '../review-rate/review-rate-type';
import {sentimentDataSchema, SentimentEnum} from '../review-sentiment/review-sentiment-type';

const listResponseProperties = r.object({
    count: r.number(),
    page: r.number(),
    pages: r.number(),
    next: r.string().nullable().optional(),
    previous: r.string().nullable().optional(),
    pageSize: r.number(),
});

const reviewsAnalysisTagSchema = r.object({
    tag: r.string(),
    avgRating: r.number(),
    total: r.number(),
    replied: r.number(),
    repliedPercent: r.number(),
    avgResponseSpeed: r.number().nullable(),
    tagReviewsPercent: r.number().nullish(),
    sentiment: sentimentDataSchema,
    trendByThreeMonths: r.array(
        r.object({
            date: r.string(),
            value: r.number(),
        })
    ),
});

export type ReviewsAnalysisTagType = r.infer<typeof reviewsAnalysisTagSchema>;

export const reviewsAnalysisUserTagSchema = r.object({
    ids: r.array(r.number()),
    title: r.string(),
    avgRating: r.number(),
    total: r.number(),
    replied: r.number(),
    sentiment: sentimentDataSchema,
    avgResponseSpeed: r.number().nullable(),
    trendByThreeMonths: r.array(
        r.object({
            date: r.string(),
            value: r.number(),
        })
    ),
});

export type ReviewsAnalysisUserTagType = r.infer<typeof reviewsAnalysisUserTagSchema>;

export type ReviwsAnalysisUserTagTableDataType = ReviewsAnalysisUserTagType & {
    key: Key;
    isCompareItem?: boolean;
    isCompareAdvantage?: boolean;
    compareItem?: ReviewsAnalysisUserTagType;
};

export const reviewsAnalysisTagResponseSchema = listResponseProperties.merge(
    r.object({
        results: r.array(reviewsAnalysisTagSchema),
    })
);
export const reviewsAnalysisTagSearchSchema = r.array(r.string());

const reviewsAnalysisTagBySentimentSchema = r.object({
    tag: r.string(),
    total: r.number(),
    sentiment: r.nativeEnum(SentimentEnum),
});

export type ReviewsAnalysisTagBySentimentType = r.infer<typeof reviewsAnalysisTagBySentimentSchema>;

export const reviewsAnalysisTagBySentimentResponseSchema = listResponseProperties.merge(
    r.object({
        results: r.array(reviewsAnalysisTagBySentimentSchema),
    })
);

export type ReviewsAnalysisTagsQueryType = {
    mode?: ReviewsAnalysisModeEnum;
    brandIds?: Array<number>;
    companyIds?: Array<number>;
    startDate: string | null;
    endDate: string | null;
    sentiments: Array<SentimentEnum>;
    sources: Array<number>;
    tags: Array<string>;
    phrases: Array<string>;
    topics: Array<string>;
    userTagsIds: Array<number>;
    aspectIds: Array<number>;
    userTopics?: Array<string>;
    rating: Array<ReviewRateEnum>;
    withAnswers: boolean | null;
    withText: boolean | null;
    ableToReply: boolean | null;
    target: string | null;
    useDeleted: boolean | null;
    maxTagsCount?: number;
};

export const reviewsAnalysisTopUserTagsResponseSchema = r.object({
    userTag: r.string(),
    avgRating: r.number(),
    reviewsCount: r.number(),
    sentiment: r.object({
        negative: r.number(),
        positive: r.number(),
        neutral: r.number(),
        unspecified: r.number(),
    }),
});

export type ReviewsAnalysisTopUserTagsType = r.infer<typeof reviewsAnalysisTopUserTagsResponseSchema>;
